/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CompanyWebhookDelivery,
  CompanyWebhookDeliveryState,
  CompanyWebhookEventType,
  CompanyWebhookResponse,
  CreateWebhookRequest,
  CreateWebhookResponse,
  RedeliverWebhookDeliveryRequest,
  RegenerateSecretResponse,
  UpdateWebhookRequest,
  WebhookDeliveriesPage,
  WebhookDeliveryDetail,
  WebhookDeliverySortKey,
} from "../models/index";
import {
  CompanyWebhookDeliveryFromJSON,
  CompanyWebhookDeliveryToJSON,
  CompanyWebhookDeliveryStateFromJSON,
  CompanyWebhookDeliveryStateToJSON,
  CompanyWebhookEventTypeFromJSON,
  CompanyWebhookEventTypeToJSON,
  CompanyWebhookResponseFromJSON,
  CompanyWebhookResponseToJSON,
  CreateWebhookRequestFromJSON,
  CreateWebhookRequestToJSON,
  CreateWebhookResponseFromJSON,
  CreateWebhookResponseToJSON,
  RedeliverWebhookDeliveryRequestFromJSON,
  RedeliverWebhookDeliveryRequestToJSON,
  RegenerateSecretResponseFromJSON,
  RegenerateSecretResponseToJSON,
  UpdateWebhookRequestFromJSON,
  UpdateWebhookRequestToJSON,
  WebhookDeliveriesPageFromJSON,
  WebhookDeliveriesPageToJSON,
  WebhookDeliveryDetailFromJSON,
  WebhookDeliveryDetailToJSON,
  WebhookDeliverySortKeyFromJSON,
  WebhookDeliverySortKeyToJSON,
} from "../models/index";

export interface CreateWebhookOperationRequest {
  createWebhookRequest: CreateWebhookRequest;
}

export interface DeleteWebhookRequest {
  webhookId: string;
}

export interface GetActiveWebhooksForCompanyRequest {
  companyId: string;
}

export interface GetActiveWebhooksForEventRequest {
  companyId: string;
  eventType: CompanyWebhookEventType;
}

export interface GetWebhookRequest {
  webhookId: string;
}

export interface GetWebhookDeliveryRequest {
  companyId: string;
  deliveryId: string;
}

export interface ListWebhookDeliveriesRequest {
  companyId: string;
  webhookId?: string | null;
  eventType?: CompanyWebhookEventType | null;
  state?: CompanyWebhookDeliveryState | null;
  createdFrom?: string | null;
  createdTo?: string | null;
  sortBy?: WebhookDeliverySortKey | null;
  descending?: boolean | null;
  page?: number | null;
  pageSize?: number | null;
}

export interface ListWebhooksForCompanyRequest {
  companyId: string;
}

export interface ReactivateWebhookRequest {
  webhookId: string;
}

export interface RedeliverWebhookDeliveryOperationRequest {
  redeliverWebhookDeliveryRequest: RedeliverWebhookDeliveryRequest;
}

export interface RegenerateSecretRequest {
  webhookId: string;
}

export interface UpdateWebhookOperationRequest {
  webhookId: string;
  updateWebhookRequest: UpdateWebhookRequest;
}

/**
 *
 */
export class CompanyWebhooksApi extends runtime.BaseAPI {
  /**
   */
  async createWebhookRaw(
    requestParameters: CreateWebhookOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateWebhookResponse>> {
    if (requestParameters["createWebhookRequest"] == null) {
      throw new runtime.RequiredError(
        "createWebhookRequest",
        'Required parameter "createWebhookRequest" was null or undefined when calling createWebhook().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/create-webhook`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateWebhookRequestToJSON(
          requestParameters["createWebhookRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateWebhookResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async createWebhook(
    requestParameters: CreateWebhookOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateWebhookResponse> {
    const response = await this.createWebhookRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async deleteWebhookRaw(
    requestParameters: DeleteWebhookRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["webhookId"] == null) {
      throw new runtime.RequiredError(
        "webhookId",
        'Required parameter "webhookId" was null or undefined when calling deleteWebhook().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["webhookId"] != null) {
      queryParameters["webhookId"] = requestParameters["webhookId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/delete-webhook`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteWebhook(
    requestParameters: DeleteWebhookRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteWebhookRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getActiveWebhooksForCompanyRaw(
    requestParameters: GetActiveWebhooksForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyWebhookResponse>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getActiveWebhooksForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/get-active-webhook`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyWebhookResponseFromJSON),
    );
  }

  /**
   */
  async getActiveWebhooksForCompany(
    requestParameters: GetActiveWebhooksForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyWebhookResponse>> {
    const response = await this.getActiveWebhooksForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getActiveWebhooksForEventRaw(
    requestParameters: GetActiveWebhooksForEventRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyWebhookResponse>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getActiveWebhooksForEvent().',
      );
    }

    if (requestParameters["eventType"] == null) {
      throw new runtime.RequiredError(
        "eventType",
        'Required parameter "eventType" was null or undefined when calling getActiveWebhooksForEvent().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["eventType"] != null) {
      queryParameters["eventType"] = requestParameters["eventType"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/get-active-webhook-for-event`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyWebhookResponseFromJSON),
    );
  }

  /**
   */
  async getActiveWebhooksForEvent(
    requestParameters: GetActiveWebhooksForEventRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyWebhookResponse>> {
    const response = await this.getActiveWebhooksForEventRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getWebhookRaw(
    requestParameters: GetWebhookRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CompanyWebhookResponse>> {
    if (requestParameters["webhookId"] == null) {
      throw new runtime.RequiredError(
        "webhookId",
        'Required parameter "webhookId" was null or undefined when calling getWebhook().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["webhookId"] != null) {
      queryParameters["webhookId"] = requestParameters["webhookId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/get-webhook`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyWebhookResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getWebhook(
    requestParameters: GetWebhookRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CompanyWebhookResponse> {
    const response = await this.getWebhookRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getWebhookDeliveryRaw(
    requestParameters: GetWebhookDeliveryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<WebhookDeliveryDetail>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getWebhookDelivery().',
      );
    }

    if (requestParameters["deliveryId"] == null) {
      throw new runtime.RequiredError(
        "deliveryId",
        'Required parameter "deliveryId" was null or undefined when calling getWebhookDelivery().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["deliveryId"] != null) {
      queryParameters["deliveryId"] = requestParameters["deliveryId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/get-webhook-delivery`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookDeliveryDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getWebhookDelivery(
    requestParameters: GetWebhookDeliveryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<WebhookDeliveryDetail> {
    const response = await this.getWebhookDeliveryRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The same list, filters and paging the customer has on the Dashboard, for support. \\[createdTo\\] is exclusive.
   * The same list, filters and paging the customer has on the Dashboard, for support.
   */
  async listWebhookDeliveriesRaw(
    requestParameters: ListWebhookDeliveriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<WebhookDeliveriesPage>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling listWebhookDeliveries().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["webhookId"] != null) {
      queryParameters["webhookId"] = requestParameters["webhookId"];
    }

    if (requestParameters["eventType"] != null) {
      queryParameters["eventType"] = requestParameters["eventType"];
    }

    if (requestParameters["state"] != null) {
      queryParameters["state"] = requestParameters["state"];
    }

    if (requestParameters["createdFrom"] != null) {
      queryParameters["createdFrom"] = requestParameters["createdFrom"];
    }

    if (requestParameters["createdTo"] != null) {
      queryParameters["createdTo"] = requestParameters["createdTo"];
    }

    if (requestParameters["sortBy"] != null) {
      queryParameters["sortBy"] = requestParameters["sortBy"];
    }

    if (requestParameters["descending"] != null) {
      queryParameters["descending"] = requestParameters["descending"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    if (requestParameters["pageSize"] != null) {
      queryParameters["pageSize"] = requestParameters["pageSize"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/list-webhook-deliveries`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookDeliveriesPageFromJSON(jsonValue),
    );
  }

  /**
   * The same list, filters and paging the customer has on the Dashboard, for support. \\[createdTo\\] is exclusive.
   * The same list, filters and paging the customer has on the Dashboard, for support.
   */
  async listWebhookDeliveries(
    requestParameters: ListWebhookDeliveriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<WebhookDeliveriesPage> {
    const response = await this.listWebhookDeliveriesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listWebhooksForCompanyRaw(
    requestParameters: ListWebhooksForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyWebhookResponse>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling listWebhooksForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/get-webhooks-for-company`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyWebhookResponseFromJSON),
    );
  }

  /**
   */
  async listWebhooksForCompany(
    requestParameters: ListWebhooksForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyWebhookResponse>> {
    const response = await this.listWebhooksForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Turns a webhook paused after repeated failures back on, once the customer fixed it.
   * Turns a webhook paused after repeated failures back on, once the customer fixed it.
   */
  async reactivateWebhookRaw(
    requestParameters: ReactivateWebhookRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["webhookId"] == null) {
      throw new runtime.RequiredError(
        "webhookId",
        'Required parameter "webhookId" was null or undefined when calling reactivateWebhook().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["webhookId"] != null) {
      queryParameters["webhookId"] = requestParameters["webhookId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/reactivate-webhook`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Turns a webhook paused after repeated failures back on, once the customer fixed it.
   * Turns a webhook paused after repeated failures back on, once the customer fixed it.
   */
  async reactivateWebhook(
    requestParameters: ReactivateWebhookRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.reactivateWebhookRaw(requestParameters, initOverrides);
  }

  /**
   * Re-sends a delivery as ops: no cap, and the operator\'s email goes on the new row.
   * Re-sends a delivery as ops: no cap, and the operator\'s email goes on the new row.
   */
  async redeliverWebhookDeliveryRaw(
    requestParameters: RedeliverWebhookDeliveryOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CompanyWebhookDelivery>> {
    if (requestParameters["redeliverWebhookDeliveryRequest"] == null) {
      throw new runtime.RequiredError(
        "redeliverWebhookDeliveryRequest",
        'Required parameter "redeliverWebhookDeliveryRequest" was null or undefined when calling redeliverWebhookDelivery().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/redeliver-webhook-delivery`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: RedeliverWebhookDeliveryRequestToJSON(
          requestParameters["redeliverWebhookDeliveryRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyWebhookDeliveryFromJSON(jsonValue),
    );
  }

  /**
   * Re-sends a delivery as ops: no cap, and the operator\'s email goes on the new row.
   * Re-sends a delivery as ops: no cap, and the operator\'s email goes on the new row.
   */
  async redeliverWebhookDelivery(
    requestParameters: RedeliverWebhookDeliveryOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CompanyWebhookDelivery> {
    const response = await this.redeliverWebhookDeliveryRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async regenerateSecretRaw(
    requestParameters: RegenerateSecretRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RegenerateSecretResponse>> {
    if (requestParameters["webhookId"] == null) {
      throw new runtime.RequiredError(
        "webhookId",
        'Required parameter "webhookId" was null or undefined when calling regenerateSecret().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["webhookId"] != null) {
      queryParameters["webhookId"] = requestParameters["webhookId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/regenerate-webhook-secret`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RegenerateSecretResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async regenerateSecret(
    requestParameters: RegenerateSecretRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RegenerateSecretResponse> {
    const response = await this.regenerateSecretRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async updateWebhookRaw(
    requestParameters: UpdateWebhookOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["webhookId"] == null) {
      throw new runtime.RequiredError(
        "webhookId",
        'Required parameter "webhookId" was null or undefined when calling updateWebhook().',
      );
    }

    if (requestParameters["updateWebhookRequest"] == null) {
      throw new runtime.RequiredError(
        "updateWebhookRequest",
        'Required parameter "updateWebhookRequest" was null or undefined when calling updateWebhook().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["webhookId"] != null) {
      queryParameters["webhookId"] = requestParameters["webhookId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-webhooks/update-webhook`,
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateWebhookRequestToJSON(
          requestParameters["updateWebhookRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateWebhook(
    requestParameters: UpdateWebhookOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateWebhookRaw(requestParameters, initOverrides);
  }
}
